import { render, staticRenderFns } from "./PlanTab2.vue?vue&type=template&id=6a62f153&scoped=true&lang=pug&"
import script from "./PlanTab2.vue?vue&type=script&lang=js&"
export * from "./PlanTab2.vue?vue&type=script&lang=js&"
import style0 from "./PlanTab2.vue?vue&type=style&index=0&id=6a62f153&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a62f153",
  null
  
)

export default component.exports